import { render, staticRenderFns } from "./checkoutDetail.vue?vue&type=template&id=3478a5c1"
import script from "./checkoutDetail.vue?vue&type=script&lang=js"
export * from "./checkoutDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports